<template>
  <div
    :class="[
      compact
        ? 'px-2 py-1'
        : 'rounded-[12px] border border-grayLight px-3 py-2',
      disabled ? 'opacity-50' : compact ? 'bg-transparent' : 'bg-white',
    ]"
  >
    <div class="flex items-stretch gap-3">
      <div
        class="shrink-0 self-stretch min-w-[60px] flex items-center justify-center px-2"
      >
        <img v-if="icon" :src="icon" alt="icon" class="w-10 h-10" />
      </div>

      <div class="flex-1 min-w-0 flex flex-col justify-center">
        <div class="min-w-0 flex items-center gap-1">
          <p class="text-[14px] font-semibold text-[#4C4D4F] truncate">
            {{ title }}
          </p>
          <span v-if="subtitle" class="text-[14px] font-semibold text-[#4C4D4F]"
            >.</span
          >
          <p v-if="subtitle" class="text-[14px] text-[#667085] truncate">
            {{ subtitle }}
          </p>
        </div>

        <div class="mt-0 flex items-center gap-3">
          <div class="flex-1">
            <div class="w-full h-2 bg-[#E5E7EB] rounded-full overflow-hidden">
              <div
                class="h-full bg-[#4C4D4F] rounded-full"
                :style="{ width: computedWidth }"
              ></div>
            </div>
          </div>

          <div class="shrink-0 flex items-center gap-2">
            <div
              v-if="badgeIcon"
              class="w-11 h-11 rounded-[8px] bg-white flex items-center justify-center"
              style="border: 1px solid #eeeeee"
            >
              <img :src="badgeIcon" alt="badge" class="w-7 h-7" />
            </div>
            <button
              type="button"
              class="w-11 h-11 p-0 bg-transparent border-0 flex items-center justify-center hover:opacity-80 active:opacity-70"
              @click="onShare"
              :aria-label="`Share ${title}`"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 1.66699V12.5003"
                  stroke="#ABABB3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M13.3334 5.00033L10.0001 1.66699L6.66675 5.00033"
                  stroke="#ABABB3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M3.33325 10V16.6667C3.33325 17.1087 3.50885 17.5326 3.82141 17.8452C4.13397 18.1577 4.55789 18.3333 4.99992 18.3333H14.9999C15.4419 18.3333 15.8659 18.1577 16.1784 17.8452C16.491 17.5326 16.6666 17.1087 16.6666 16.6667V10"
                  stroke="#ABABB3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AchievementsProgressRow",
  props: {
    icon: String,
    title: { type: String, required: true },
    subtitle: String,
    progress: { type: Number, default: 0 },
    progressText: String,
    disabled: { type: Boolean, default: false },
    badgeIcon: String,
    compact: { type: Boolean, default: false },
  },
  emits: ["share"],
  computed: {
    computedWidth() {
      const pct = Math.max(0, Math.min(100, this.progress || 0));
      return pct + "%";
    },
  },
  methods: {
    async onShare() {
      const text = this.buildShareText();
      if (navigator.share) {
        try {
          await navigator.share({
            title: this.title,
            text,
          });
          this.$emit("share", {
            title: this.title,
            subtitle: this.subtitle,
            progress: this.progress,
          });
          return;
        } catch (e) {
          console.warn("Share failed or was cancelled", e);
        }
      }

      try {
        await navigator.clipboard.writeText(text);
        this.$emit("share", { copied: true, title: this.title });
      } catch (e) {
        window.prompt("Copy achievement details:", text);
      }
    },
    buildShareText() {
      const pieces = [this.title];
      if (this.subtitle) pieces.push(this.subtitle);
      if (typeof this.progress === "number")
        pieces.push(`Progress: ${Math.max(0, Math.min(100, this.progress))}%`);
      return pieces.join(" • ");
    },
  },
};
</script>

<style scoped>
</style>
